<div class="contact-form">
  <h2>{{ recieved ? "Thanks for reaching out to us!" : "Contact Us" }}</h2>

  @if (recieved == false) {
    <p>
      Hey, thanks for visiting our website. If you landed here, you probably
      have a question, or you'd like to talk to someone on our team.
    </p>
    <p>
      First, let's find out what you need. Please select the reason you are
      contacting us below. We'd appreciate a little more information so we know
      who can help you. Fill in the comment box with a description of your
      request or question.
    </p>
    <div class="user-info-section">
      <mat-form-field appearance="outline" class="user-info">
        <mat-label>Full Name</mat-label>
        <input matInput [(ngModel)]="responses.fullName" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="user-info">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="responses.email" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="user-info">
        <mat-label>Department/Unit/Org</mat-label>
        <input matInput [(ngModel)]="responses.department" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="user-info">
        <mat-label>Job title</mat-label>
        <input matInput [(ngModel)]="responses.jobTitle" />
      </mat-form-field>
    </div>
    <div class="subject-section">
      <strong>I'd like to talk about</strong>
      <mat-form-field appearance="outline">
        <mat-label>Reason for contacting</mat-label>
        <mat-select [(ngModel)]="responses.reasonForContacting">
          <mat-option value="data_needed">Data needed</mat-option>
          <mat-option value="data_to_share">Data to share</mat-option>
          <mat-option value="tool_idea">Tool idea</mat-option>
          <mat-option value="research_to_share">Research to share</mat-option>
          <mat-option value="link_this">Link this on KX</mat-option>
          <mat-option value="website_issue">Website issue</mat-option>
          <mat-option value="other">Other</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="message-section">
      <strong>Your Message</strong>
      <mat-form-field appearance="outline">
        <mat-label>Message</mat-label>
        <textarea
          [(ngModel)]="responses.message"
          matInput
          placeholder="I have a question/comment/concern about..."
          rows="6"
        ></textarea>
      </mat-form-field>
    </div>
    <button
      mat-flat-button
      color="primary"
      (click)="submit()"
      [disabled]="responses.message == ''"
    >
      Submit
    </button>
  } @else {
    <p>Your response has been submitted.</p>
    <p>
      Our goal is to get back to you within 24 hours, but sometimes we get lost
      in research and data. We promise to let you know we're working on your
      request!
    </p>
  }
</div>
